import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import { useShowTaxesInfo } from '../../../../../../../hooks';
import Button from '../../../../../../../BaseComponents/Button';
import Money from '../../../../../../../Money/components/Money';
import PriceInMiles from '../../../../../../../PriceInMiles/PriceInMiles';
import { TaxesCollapse } from '../../../TaxesCollapse';
import { CdnIcon } from '@shared/ui';
const FareButton = ({ priceInMiles, price, subscribed, originalPrice, passengerFares, onClick, disabled, selected, className, onTouchEndCapture }) => {
    const { FareButton: css } = useTheme('Entities').FareGroupV2;
    const { t } = useTranslation('FareGroup');
    const showTaxesInfo = useShowTaxesInfo();
    const showOriginalPrice = originalPrice && originalPrice.amount !== price.amount;
    const isSelected = selected && !disabled;
    const isSubscribed = subscribed && !isSelected;
    const btnClassName = cn(css.root, className, {
        [css.selected]: isSelected,
        [css.subscribed]: isSubscribed
    });
    const buttonContent = (React.createElement(React.Fragment, null, !disabled ? (React.createElement(React.Fragment, null,
        !showOriginalPrice && React.createElement("span", { className: css.title }, t(isSelected ? 'Selected' : 'Select')),
        priceInMiles ? (React.createElement(PriceInMiles, { amount: priceInMiles, amountClassName: css.miles_amount, moneyClassName: css.miles })) : (React.createElement("div", { className: cn(css.money_wrapper, { [css.money_wrapper_center]: showOriginalPrice }) },
            showOriginalPrice && (React.createElement(Money, { moneyClassName: css.money_original, strikethrough: true, money: originalPrice })),
            React.createElement(Money, { moneyClassName: css.money, money: price }))))) : (React.createElement(React.Fragment, null, t('Unavailable')))));
    if (showTaxesInfo && isSelected && (passengerFares === null || passengerFares === void 0 ? void 0 : passengerFares.length)) {
        return (React.createElement(TaxesCollapse, { className: btnClassName, taxesDetails: { passengerFares, totalPrice: price } },
            isSelected && React.createElement(CdnIcon, { icon: "Info/Choosed" }),
            buttonContent,
            disabled && React.createElement(CdnIcon, { icon: "Info/Not included" })));
    }
    return (React.createElement(Button, { classes: {
            root: btnClassName,
            disabled: css.disabled,
            endIcon: css.endIcon,
            startIcon: css.startIcon
        }, disabled: disabled, onClick: onClick, startIcon: isSelected && React.createElement(CdnIcon, { icon: "Info/Choosed" }), endIcon: disabled && React.createElement(CdnIcon, { icon: "Info/Not included" }), onTouchEndCapture: onTouchEndCapture, disableRipple: isSelected }, buttonContent));
};
export default FareButton;
